<template>
  <div>
    <MineHeaderView @click-icon="openMenu" />
    <MineMenuView ref="mmv" />
    <div class="home-area" style="margin-top: 40px">
      <van-cell-group v-if="usrData">
        <van-cell
          title="商家认证"
          :value="usrData.rzstatus_text"
          is-link
          to="/certification"
        />
        <!--<van-cell
          title="交易密码"
          :value="usrData.has_pay_password != 1 ? '未设置' : '已设置'"
          is-link
          to="/editusr"
        />-->
        <van-cell
          title="绑定钱包/收款方式"
          :value="usrData.has_wallet != 1 ? '未设置' : '已设置'"
          is-link
          to="/editusr"
        />
      </van-cell-group>
    </div>
    <div class="home-area">
      <div class="btn-pro">
        <van-button v-if="checkCode == 200"
          icon="plus"
          style="background-color: #141423; color: #fff; border-radius: 8px"
          block
          @click="openMenu()"
          >进入藏品商铺</van-button
        >
        <van-button v-else-if="checkCode == 221"
          icon="manager-o"
          style="background-color: #141423; color: #fff; border-radius: 8px"
          block
          @click="$router.push({ name: 'certification' }, () => {})"
          >认证身份</van-button
        >
        <van-button v-else-if="checkCode == 222"
          icon="manager-o"
          style="background-color: #141423; color: #fff; border-radius: 8px"
          block
          @click="OpenSeller()"
          >开设店铺</van-button
        >
      </div>
      <div class="pro-lst">
        <div class="container">
          <van-pull-refresh v-model="isrefresh" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="list && list.length > 0 ? '没有更多了' : ''"
              @load="onLoad"
              class="waterfall"
            >
              <MyHomeProductView
                v-for="(item, index) in list"
                :key="index"
                :item="item"
                @refresh-data="onRefresh"
              />
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="container" v-if="list && list.length == 0">
          <van-empty description="当前没有商品" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  MineHeaderView,
  MineMenuView,
  MyHomeProductView
} from './components/index'
export default {
  name: 'MineView',
  data () {
    return {
      checkCode:null,
      isrefresh: false,
      loading: false,
      finished: false,
      list: null,
      usrData: null,
      page: 1,
      limit: 10
    }
  },
  components: { MineHeaderView, MineMenuView, MyHomeProductView },
  mounted () {
    this.checkUsr()
    
  },
  methods: {
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    async checkUsr () {
      await this.$http({
        method: 'post',
        url: 'check'
      }).then(res => {
        this.checkCode = res.data.check_code
        this.getUsr()
      })
    },
    async getUsr () {
      await this.$http({
        method: 'post',
        url: 'getusr'
      }).then(res => {
        this.usrData = res.data
      })
    },
    async OpenSeller () {
      await this.$http({
        method: 'post',
        url: 'openseller'
      }).then(res => {
        this.$toast.success(res.msg)
        setTimeout(() => {
                        location.reload()
                    }, 2000);
        
      })
    },
    onRefresh () {
      this.list = null
      this.isrefresh = true
      this.finished = false
      this.page = 1
    },
    async onLoad () {
      await this.$http({
        method: 'post',
        url: 'getproduct',
        data: { page: this.page, limit: this.limit }
      })
        .then(res => {
          this.loading = false
          this.isrefresh = false
          if (!this.list) this.list = res.data.list
          else {
            this.list = this.list.concat(res.data.list)
          }
          if (this.list.length >= res.data.pagination.count) {
            this.finished = true
          } else {
            this.page += 1
          }
        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.home-area {
  margin: 10px 10px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .btn-pro {
    margin: 10px 10px;
  }
  .pro-lst {
    height: calc(100vh - 350px);
    overflow-y: auto;
  }
}

.container {
  margin: 0 auto;
}

.waterfall {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  grid-auto-flow: dense;
  padding: 10px;
}
</style>
